import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { Mail, Clock, MessageSquare, FileText, Shield } from 'lucide-react';

const Contact = () => (
  <LegalLayout title="Contact &amp; Support" lastUpdated="August 8, 2026">
    <p>
      Need help with Create by Lumera? We're here to assist. Below you'll find the best way to reach us depending on your situation.
    </p>

    <h2>General Support</h2>
    <div className="not-prose grid gap-4 my-6">
      <div className="flex items-start gap-4 p-5 bg-white border border-stone-100 rounded-2xl shadow-sm">
        <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Mail className="w-5 h-5 text-primary" />
        </div>
        <div>
          <p className="font-sans font-bold text-stone-800 text-sm">Email Support</p>
          <p className="font-sans text-stone-500 text-xs mt-1">For all inquiries — account issues, technical problems, feature requests, or general questions.</p>
          <a href="mailto:support@createbylumera.com" className="inline-block mt-2 font-sans font-semibold text-primary text-sm hover:underline">
            support@createbylumera.com
          </a>
        </div>
      </div>

      <div className="flex items-start gap-4 p-5 bg-white border border-stone-100 rounded-2xl shadow-sm">
        <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center flex-shrink-0">
          <Clock className="w-5 h-5 text-emerald-500" />
        </div>
        <div>
          <p className="font-sans font-bold text-stone-800 text-sm">Response Time</p>
          <p className="font-sans text-stone-500 text-xs mt-1">We aim to respond to all emails within <strong>1–3 business days</strong>. Pro subscribers receive priority support.</p>
        </div>
      </div>
    </div>

    <h2>Common Topics</h2>
    <div className="not-prose grid gap-3 my-6">
      <div className="flex items-start gap-3 p-4 bg-stone-50 rounded-xl">
        <MessageSquare className="w-4 h-4 text-stone-400 mt-0.5 flex-shrink-0" />
        <div>
          <p className="font-sans font-semibold text-stone-700 text-xs">Subscription &amp; Billing</p>
          <p className="font-sans text-stone-500 text-xs mt-0.5">Cancel, reactivate, or manage your Pro subscription from your <a href="/profile" className="text-primary hover:underline">Profile page</a>. For refund requests, see our <a href="/refund-policy" className="text-primary hover:underline">Refund Policy</a>.</p>
        </div>
      </div>
      <div className="flex items-start gap-3 p-4 bg-stone-50 rounded-xl">
        <FileText className="w-4 h-4 text-stone-400 mt-0.5 flex-shrink-0" />
        <div>
          <p className="font-sans font-semibold text-stone-700 text-xs">Integrations (Shopify, Pinterest)</p>
          <p className="font-sans text-stone-500 text-xs mt-0.5">Having trouble connecting? Check the setup guide on the <a href="/profile" className="text-primary hover:underline">Integrations tab</a> in your profile, or email us with details.</p>
        </div>
      </div>
      <div className="flex items-start gap-3 p-4 bg-stone-50 rounded-xl">
        <Shield className="w-4 h-4 text-stone-400 mt-0.5 flex-shrink-0" />
        <div>
          <p className="font-sans font-semibold text-stone-700 text-xs">Privacy &amp; Data Requests</p>
          <p className="font-sans text-stone-500 text-xs mt-0.5">To exercise your data rights (access, deletion, portability), email <strong>support@createbylumera.com</strong> with the subject line "Data Request".</p>
        </div>
      </div>
    </div>

    <h2>Report Abuse</h2>
    <p>
      If you encounter content or behavior that violates our <a href="/terms">Terms of Service</a>, please report it to <strong>support@createbylumera.com</strong> with the subject line "Abuse Report" and include as much detail as possible.
    </p>

    <h2>Business Inquiries</h2>
    <p>
      For partnership, press, or business development inquiries, contact us at <strong>support@createbylumera.com</strong>.
    </p>

    <h2>Company Information</h2>
    <ul>
      <li><strong>Name:</strong> Create by Lumera</li>
      <li><strong>Website:</strong> <a href="https://createbylumera.com">createbylumera.com</a></li>
      <li><strong>Email:</strong> support@createbylumera.com</li>
    </ul>
  </LegalLayout>
);

export default Contact;
